import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import '../GamePage/GamePage.css';

const SentencePage = (props) => {
 
    return(
        <div>
            <img src={props.srcBg} className='smallBg' alt=' ' />
				<Text className = 'GameQuestion'  value = {props.topMenu} />  
				<img  src = {props.src} className =  'gameImg ' alt = ' ' /> 
                <Text className = 'GameText'  value = {props.curSentens} /> 
               	<Button className = 'PrevSentence'  onClick = {() => props.onClick('prev')}  hidden = {(props.step === 0) ? true : false} /> 
               	<Button className = 'NextSentence'  onClick = {() => props.onClick('nextSentence')}  /> 
            </div>  
    );
};
export default SentencePage;